import { Helmet } from "react-helmet";

const Terms = () => {
	return (

		<>
			<Helmet>
				<title>Terms of Use</title>
				<meta name="robots" content="noindex, nofollow" />
			</Helmet>
			<div className="page policy">
				<h1>Emissary Health, Inc. Terms of Use</h1>
				<div className="update">Last update: February 02, 2022</div>

				<h2>These Terms of Use (the “Terms” or “Agreement”) set forth the terms and conditions
					under which individuals residing in the United States may use the Emissary Health Site.
				</h2>
				<ul className="list-dot">
					<li>
						<p>
							Please read these Terms and any applicable Additional Terms before using the
							Site . By using the Site, you hereby represent, warrant, understand, agree to and
							accept these Terms and any applicable Additional Terms in their entirety whether
							or not you register as a user of the Site (“Registered Users”).
						</p>
					</li>
					<li>
						<p>
							This Agreement contains an Agreement to Arbitrate, which will, with limited
							exception, require you to submit claims you have against Emissary Health to
							binding and final arbitration, unless you opt out of the Agreement to Arbitrate
							(see Section 13 “Agreement to Arbitrate”) no later than 30 days after the date you
							first use the Emissary Health Site. Unless you opt out: (1) you will only be
							permitted to pursue claims against Emissary Health on an individual basis, not as
							a plaintiff or class member in any class or representative action or proceeding,
							and (2) you will only be permitted to seek relief (including monetary, injunctive,
							and declaratory relief) on an individual basis.
						</p>
					</li>
					<li>
						<p>
							These Terms include the Emissary Health Privacy Policy, which is incorporated
							herein. If you object to anything in these Terms, the Privacy Policy or any
							applicable Additional Terms, do not use the Site
						</p>
					</li>
					<li>
						<p>
							These Terms are subject to change by Emissary Health at any time, subject to
							the following notification process. We will notify you about material changes in
							these Terms by sending a notice to the email address registered in your account,
							or by placing a prominent notice on our Site, so that you can choose whether to
							continue using our Services. Material changes will go into effect no less than 30
							days after we notify you. Non-material changes or clarifications will take effect
							immediately upon posting of the updated Terms on our Site. You should
							periodically check our website for updates. Any use of the Site by you after the
							effective date of any changes will constitute your acceptance of such changes.
							These Terms supersede all prior versions of the Terms.
						</p>
					</li>
				</ul>

				<div className="divider"></div>

				<p>
					For purposes of these Terms, and except to the extent expressly excluded below, the
					“Site” shall mean https://emissaryhealth.org and any other websites, web pages, mobile
					applications and mobile websites operated by Emissary Health, Inc. (“Emissary Health”
					or “we”) in the United States.
				</p>

				<div className="divider"></div>

				<p>
					However, the term “Site” does not include the following:
				</p>

				<ul className="list-dot">
					<li>
						<p>
							Websites, web pages, mobile applications, and mobile websites (and services
							offered through such channels) operated by Emissary Health which have separate terms of service that do not expressly incorporate these Terms by
							reference.
						</p>
					</li>
					<li>
						<p>		Third-party entities such as in-home care agencies and other corporate care
							providers that may use the Emissary Health Site to market their services and/or
							recruit employees.</p>
					</li>
				</ul>

				<div className="divider" />
				<p><b>1. Description of Services; Limitations; User Responsibilities</b></p>

				<p>
					<b>1.1 About Our Site</b>
				</p>
				<p>
					The Emissary Health Site helps users facilitate, find, coordinate, and maintain quality
					care. The Services we offer include, among others:
				</p>
				<ul className="list-hollow-dot">
					<li>
						<p>
							We provide a platform for individuals seeking respite
							care services for themselves or family members (each
							“Care Manager”) to look for caregivers on the Site, and
							to search for, narrow, find, and communicate with
							individuals who provide respite care services (“Care
							Providers”), and for Care Providers to post profiles on
							the Site and respond to requests for jobs.
						</p>
					</li>
					<li>
						<p>
							We provide tools and information to help Care
							Managers and Care Providers make more informed
							decisions, such as (i) our Safety Information which
							includes a safety guide and precautions when
							navigating the Site, (ii) verification dashboards on Care
							Provider profiles, which enable Care Managers to check
							the status of a Care Provider’s various verifications
						</p>
					</li>
					<li>
						<p>
							We offer through Paypal, Inc., (“Paypal”), a third party, a
							service that facilitates the payment of Care Providers by
							Care Managers via credit card or debit card. These
							payment processing services are provided by Paypal
							and are subject to the
							https://www.paypal.com/us/legalhub/useragreement-full,
							the “Paypal Agreement”. By agreeing to these Terms,
							Care Providers that use the payment service also agree
							to be bound by the Paypal Agreement, as the same may
							be modified by Paypal from time to time. As a condition
							of Emissary Health enabling payment processing
							services through Paypal, you agree to provide Emissary
							Health accurate and complete information about you,
							and you authorize Emissary Health to share it and
							transaction information related to your use of the
							payment processing services provided by Paypal.
							Emissary Health assumes no liability or responsibility for
							any payments you may make through this service, and
							all such payments are non-refundable. Care Providers
							who elect to receive payments from Care Managers
							through this service can also qualify for certain benefits
							under a program operated by Emissary Health.
						</p>
					</li>
				</ul>

				<div className="divider" />

				<p>
					<b>
						1.2 Limitations of our Site
					</b>
				</p>
				<p>
					Our Site is built to help our users find, coordinate, and maintain care for their families.
					However, except where specifically provided in these Terms, in any applicable
					Additional Terms, or on the Site itself.
				</p>
				<ul className="list-hollow-dot">
					<li>
						<p>
							We do not employ any Care Providers and are not
							responsible for the conduct, whether online or offline, of
							any Care Manager, Care Provider, or other user of the
							Site. Care Managers are responsible for compliance
							with all applicable employment and other laws in
							connection with any employment relationship they
							establish.
						</p>
					</li>
					<li>
						<p>
							Care Manager and Care Provider content is primarily
							user generated. We do not control or vet user-generated
							content for accuracy, and we do not assume and
							expressly disclaim any responsibility for the accuracy or
							reliability of any information provided by Care Providers
							or Care Managers on or off the Site. We do not assume
							and expressly disclaim any liability that may result from
							the use of information provided on our Site.
						</p>
					</li>
					<li>
						<p>
							We do not refer or recommend Care Managers or Care
							Providers nor do we make any representations about
							the suitability, reliability, timeliness, or accuracy of the
							services provided by Care Providers or the integrity,
							responsibility or actions of Care Managers or Care
							Providers whether in public, private or offline
							interactions. Any screening of a Care Manager or Care
							Provider and his, her or its information by Emissary
							Health is limited and should not be taken as complete,
							accurate, up-to-date or conclusive of the individual’s or
							entity’s suitability as an employer or care provider.
						</p>
					</li>
					<li>
						<p>
							We are not an employment agency, and we do not
							secure or procure employees for any Care Managers,
							nor do we secure or procure opportunities for
							employment for any Care Providers.
						</p>
					</li>
					<li>
						<p>
							We do not control, monitor, supervise, or oversee the
							quality, timing, hours, pay, legality, or any other aspect
							of services delivered by Care Providers, nor do we
							require Care Providers to accept or work any jobs or
							deliver any services at all.
						</p>
					</li>
					<li>
						<p>
							We do not provide any medical, diagnostic, treatment or
							clinical service or engage in any conduct that requires a
							professional license.
						</p>
					</li>
				</ul>

				<div className="divider" />

				<p><b>1.3 User Responsibilities</b></p>
				<p>
					Registered Users are solely responsible for vetting, performing background and
					reference checks on, verifying information provided by, and selecting an appropriate
					Care Manager or Care Provider for themselves or their family.<br /><br />
					Please visit our Safety Center for advice on selection decisions.
				</p>
				<div className="divider" />

				<p>
					<b>2. Eligibility to Use the Site</b>
				</p>

				<p>
					By requesting to use, registering to use and/or using the Site, you represent and
					warrant that you have the right, authority and capacity to enter into these Terms and you
					commit to abide by all of the terms and conditions hereof. You also represent and
					warrant that you meet the following eligibility criteria:
				</p>
				<ul className="list-hollow-dot">
					<li>
						<p>
							You intend to use the Site solely for the purpose of finding or
							managing care or care-related jobs, or for finding or sharing
							information relating to care.
						</p>
					</li>
					<li>
						<p>
							Our Site is available only to individuals who are eighteen (18) years
							of age or older. If you do not meet this age requirement, do not
							register to use the Site.
						</p>
					</li>
					<li>
						<p>
							The Site is currently available only to individuals who reside legally
							in the United States.
						</p>
					</li>
					<li>
						<p>
							If you are registering to be a Care Provider, you must be permitted to
							legally work within the United States.
						</p>
					</li>
					<li>
						<p>Neither you nor any member of your household may have ever been:</p>
						<ul className="list-hollow-dot">
							<li>
								<p>
									the subject of a conviction, arrest, charge, complaint, restraining
									order or any other legal action involving:
								</p>
								<ul className="list-hollow-dot">
									<li>
										<p>any felony;</p>
									</li>
									<li>
										<p>
											any other criminal offense involving violence, physical, sexual,
											or emotional abuse or neglect, or theft, drugs, or
										</p>
									</li>
									<li>
										<p>
											any offense, violation, or unlawful act that involves endangering
											the safety of others, fraud, dishonesty, or reckless or negligent
											conduct.
										</p>
									</li>
								</ul>
							</li>
							<li>
								<p>
									registered, or currently required to register, as a sex
									offender with any government entity.
								</p>
							</li>
						</ul>
					</li>
				</ul>

				<div className="divider" />

				<p><b>3. Rules for User Conduct and Use of Site</b></p>

				<p>
					<b>
						3.1 Registration, Posting, and Content Restrictions
					</b>
				</p>
				<p>
					The following rules pertain to “Content”, defined as any communications, images,
					sounds, videos, and all the material, data, and information that you upload or transmit
					through the Site, whether to Emissary Health or to other Registered Users or Site
					Visitors, or that other users upload or transmit, including without limitation any content,
					messages, photos, audios, videos, reviews or profiles that you publish or display
					(hereinafter, “post”):
				</p>

				<div className="divider"></div>

				<ul className="list-dot">
					<li>
						<p>
							Any Content that you post, upload or transmit to or through the Site is solely for
							the purpose of finding or managing care or care-related jobs, or for finding or
							sharing information relating to care.
						</p>
					</li>
					<li>
						<p>
							You are responsible for providing accurate, current and complete information in
							connection with your registration for use of the Site.
						</p>
					</li>
					<li>
						<p>
							You will register your account in your own legal name, even if you are seeking
							care for another individual or family member.
						</p>
					</li>
					<li>
						<p>
							Unless otherwise permitted by Emissary Health, all Content you post will be in
							English as the site generally is not supported in any other languages.
						</p>
					</li>
					<li>
						<p>
							You are solely responsible for any Content that you post on the Site or transmit to
							other users of the Site. You will not post on the Site, or transmit to other users,
							any defamatory, inaccurate, abusive, obscene, profane, offensive, sexually
							oriented, threatening, harassing, defamatory, racially offensive, or illegal material,
							or any material that infringes or violates another party’s rights (including, but not
							limited to, intellectual property rights, and rights of privacy and publicity), or
							advocate, promote or assist any unlawful act such as (by way of example only)
							copyright infringement or computer misuse, or give the impression that any
							Content emanates from Emissary Health where this is not the case. You will not
							provide inaccurate, misleading, defamatory or false information to Emissary
							Health or to any other user of the Site, and all opinions stated as part of Content
							must be genuinely held. Without limiting the foregoing, you represent and warrant
							to us that you have the right and authority to post all information you post about
							yourself or others, including without limitation that you have authorization from a
							parent or guardian of any minor who is the subject of any Content you post to
							post such Content.
						</p>
					</li>
					<li>
						<p>
							You understand and agree that Emissary Health may, in its sole discretion,
							review, edit, and delete any Content, in each case in whole or in part, that in the
							sole judgment of Emissary Health violates these Terms or which Emissary Health
							determines in its sole discretion might be offensive, inappropriate, illegal, or that
							might violate the rights, harm, or threaten the safety of users of the Site or others.
						</p>
					</li>
					<li>
						<p>
							You have the right, and hereby grant, to Emissary Health, its Affiliates, licensees
							and successors, an irrevocable, perpetual, non-exclusive, fully paid-up,
							transferable, worldwide license to use, copy, perform, display, reproduce, adapt,
							modify and distribute your Content and to prepare derivative works of, or
							incorporate into other works, such Content, and to grant and authorize
							sublicenses of the foregoing. You further represent and warrant that public
							posting and use of your Content by Emissary Health will not infringe or violate the
							rights of any third party.
						</p>
					</li>
					<li>
						<p>
							Your use of the Services, including but not limited to the Content you post on the
							Site, must be in accordance with any and all applicable laws and regulations.
						</p>
					</li>
					<li>
						<p>
							We welcome your feedback and questions about the site. However, you agree
							that any comments, ideas, messages, questions, suggestions, or other
							communications you send to us or share with us through any channel (including,
							without limitation, the Site, email, telephone, surveys, and our social media
							accounts) shall be and remain the exclusive property of Emissary Health and we
							may use all such communications, all without notice to, consent from, or
							compensation to you.
						</p>
					</li>
				</ul>

				<p>
					As Care Manager and Care Provider Content is primarily user generated, we do not
					control or vet such Content for accuracy, and we do not assume and expressly disclaim
					any responsibility for the accuracy or reliability of any Content provided by Care
					Providers or Care Managers on or off the Site, including any Content that may include
					misstatements or misrepresentations or that may be defamatory or disparaging. Users
					hereby represent, understand and agree to hold Emissary Health harmless for any
					misstatements, misrepresentations, or other disparaging or defamatory statements
					made by or on behalf of them on this Site or in any other venue.
					<br /><br />
					Opinions, advice, statements, offers, or other information or content made available on
					the Site or through the Site, but not directly by Emissary Health, are those of their
					respective authors. Such authors are solely responsible for such content. Emissary
					Health does not: (i) guarantee the accuracy, completeness, or usefulness of any
					information on the Site or available through the Service, or (ii) adopt, endorse or accept
					responsibility for the accuracy or reliability of any opinion, advice, or statement made by
					any party that appears on the Site or through the Service. Under no circumstances will
					Emissary Health or its Affiliates be responsible for any loss or damage resulting from:
					(a) your reliance on information or other content posted on the Site or transmitted to or
					by any user of the Site or Service; or (b) reviews or comments made about you on the
					Site by other users.
					<br /><br />
					You agree that Emissary Health has no obligation to remove any reviews or other
					information posted on the Site about you or any other person or entity. You may not
					terminate your registration and re-register in order to prevent a review from being
					associated with your account. The author of a review can always request removal of a
					review they have written.
				</p>
				<div className="divider"></div>

				<p>
					<b>
						3.2 Exclusive Use
					</b>
				</p>
				<p>

					If you are a Care Manager, you may use your account only to find care for yourself, your
					parents, your children, your grandchildren, or individuals for whom you are otherwise
					the legal guardian. If you are a Care Provider, you may use your account only to find
					care jobs for yourself. You are responsible for all activity on and use of your account,
					and you may not assign or otherwise transfer your account to any other person or entity.
				</p>
				<div className="divider"></div>

				<p>
					<b>
						3.3 Prohibited Uses
					</b>
				</p>
				<p>			By using the Site of Emissary Health, you agree that you will not under any
					circumstances:</p>
				<ul className="list-hollow-dot">
					<li>
						<p>
							use the Site, Services, or any information contained
							therein in any way that is abusive, threatening, obscene,
							defamatory, libelous, or racially, sexually, religiously, or
							otherwise objectionable or offensive;
						</p>
					</li>
					<li>
						<p>
							use the Site for any fraudulent or unlawful purpose, for
							any purpose unrelated to care or caregiving, or for any
							other purpose not expressly intended by Emissary
							Health;
						</p>
					</li>
					<li>
						<p>
							harass, abuse or harm another person or group, or
							attempt to do so;
						</p>
					</li>
					<li>
						<p>
							use another user’s Emissary Health account;
						</p>
					</li>
					<li>
						<p>
							provide false or inaccurate information when registering
							an account on Emissary Health, using the Services or
							communicating with other Registered Users;
						</p>
					</li>
					<li>
						<p>
							attempt to re-register with Emissary Health if we have
							terminated your account for any or no reason or
							terminate your registration and re-register in order to
							prevent a review from being associated with your
							account;
						</p>
					</li>
					<li>
						<p>
							interfere or attempt to interfere with the proper
							functioning of Emissary Health’s Services;
						</p>
					</li>
					<li>
						<p>
							make any automated use of the system, or take any
							action that we deem to impose or to potentially impose
							an unreasonable or disproportionately large load on our
							servers or network infrastructure;
						</p>
					</li>
					<li>
						<p>
							bypass any robot exclusion headers or other measures
							we take to restrict access to the Service or use any
							software, technology, or device to scrape, spider, or
							crawl the Service or harvest or manipulate data
							(whether manually or through automated means);
						</p>
					</li>
					<li>
						<p>
							use the communication systems provided by or contacts
							made on Emissary Health for any commercial
							solicitation purposes other than those expressly
							permitted by Emissary Health;
						</p>
					</li>
					<li>
						<p>
							publish or link to malicious content intended to damage
							or disrupt another user’s browser or computer. In order
							to protect our users from prohibited activity, we reserve
							the right to take appropriate actions, including but not
							limited to restricting the amount of messages a user
							may send in any 24-hour period to an amount which we
							deem appropriate in our sole discretion. Should
							Emissary Health find that you violated the terms of this
							Section or any terms stated herein, Emissary Health
							reserves the right, at its sole discretion, to immediately
							terminate your use of the site. By using the Site and/,
							you agree that Emissary Health may assess, and you
							will be obligated to pay, $10,000 per each day that you:
							(i) maintain Care Provider or Care Manager information
							(including but not limited to, names, addresses, phone
							numbers, or email addresses) or copyrighted material
							that you scraped (either directly or indirectly in a manual
							or automatic manner) from the Site, or (ii) otherwise
							mis-use or mis-appropriate Site Content, including but
							not limited to, use on a “mirrored”, competitive, or third
							party site. This obligation shall be in addition to any
							other rights Emissary Health may have under these
							Terms or applicable law. Further, in order to protect the
							integrity of the Site and the Services, Emissary Health
							reserves the right at any time in its sole discretion to
							block users from certain IP addresses from accessing
							the Site.
						</p>
					</li>
				</ul>

				<div className="divider" />

				<p>
					<b>Background and Verification Checks</b>
				</p>

				<p>
					<b>
						4.1 Care Providers Can Order or Authorize Background Checks about Themselves
					</b>
				</p>
				<p>
					Emissary Health offers to individuals who have registered as Care Providers one or
					more background check services from third-party consumer reporting agencies
					(“Background Checks”). Certain background checks may be made available for
					purchase by both Care Managers and Care Providers. All background checks require
					payment of a separate fee by the Member who is initiating the background check
					request and are subject to the consent of the Care Provider on whom the check is being
					performed.<br /><br />
					Each of these Background Checks is regulated by the Fair Credit Reporting Act
					(“FCRA”), and the background reports resulting from these services are considered
					“consumer reports” under FCRA. Consumer reports may contain information on your
					character, general reputation, personal characteristics, and mode of living, including but
					not limited to consumer credit, criminal history, workers’ compensation, driving,
					employment, military, civil, and educational data and reports.<br /><br />
					Emissary Health will receive a copy of each Background Check you order or authorize
					through Emissary Health. You are responsible for making sure that the email address
					you provide to Emissary Health is correct, knowing that sensitive information will be sent
					to it.
				</p>

				<div className="divider" />

				<p>
					<b>4.2 Special Responsibilities of Users of Background Check under FCRA</b>
				</p>
				<p>
					The use of any background check reports obtained through the Site is governed by the
					federal Fair Credit Reporting Act (“FCRA”) and certain state laws. If you order a
					background check you are considered an end user of the check, and must agree to a
					required End User Certification before the check will be processed. This End User
					Certification requires you to certify that you will comply with the FCRA and any
					applicable state laws, and summarizes key legal obligations. If you contest the report
					with the consumer reporting agency, we are required to suspend the onboarding
					process while the agency researches the accuracy and completeness of the report.
				</p>

				<div className="divider" />

				<p>
					<b>
						4.3 Emissary Health May Review and Use Background Checks You Order or Authorize
						About Yourself
					</b>
				</p>

				<p>
					By registering for and using the Site as an individual Care Provider, and subject to your
					authorization, you acknowledge and agree that Emissary Health may review and use
					any Background Checks you have ordered or authorized about yourself for the purpose
					of protecting the safety and integrity of our Site and its users. Emissary Health reserves
					the right to terminate your membership based on the information contained in such
					report, even if such information was subsequently dismissed.<br /><br />
					If Emissary Health terminates your membership or access to the Site on the basis of
					information in a Background Check, we will notify you and provide you the name and
					contact information of the consumer reporting agency that created the report. We will
					also provide you a copy of the report unless the consumer reporting agency has already
					provided you a copy or access to it. You hereby represent, understand and expressly
					agree that Emissary Health does not have control over or assume any responsibility for
					the quality, accuracy, or reliability of the information included in these Background
					Checks. Furthermore, any inaccuracies in the report must be addressed with the
					consumer reporting agency that issued it and not Emissary Health.
				</p>


				<div className="divider" />
				<p>
					<b>
						4.4 Emissary Health May Order and Use Background Screenings About You
					</b>
				</p>

				<p>By registering for and using the Site as a Care Provider, you hereby acknowledge and
					agree that Emissary Health has the right, but not the obligation, to use a third-party
					consumer reporting agency on an ongoing basis to use your personal information to run
					periodic background screenings on you for the purpose of protecting the safety and
					integrity of our Site and its users. Subject to certain additional disclosures and
					authorizations, if applicable to you as a Care Provider, Emissary Health may order these
					screenings when you register with Emissary Health and thereafter in connection with
					your continued use of our Services and/or interaction with our Site (such as by
					contacting or communicating with other members, posting or updating a job or profile,
					ordering or authorizing a Background Check, etc.).<br /><br />
					You understand and agree that Emissary Health may review the information provided by
					the third-party consumer reporting agency and that Emissary Health retains the right to
					terminate your Emissary Health registration based on the information it receives from
					these checks, even if such information was subsequently changed or corrected. If
					Emissary Health terminates your membership or access to the Site on the basis of
					information in a background report, we will notify you and provide you the name and
					contact information of the consumer reporting agency that created the report. We will
					also provide you access to a copy of the report unless the consumer reporting agency
					has already provided you a copy or access to it. You hereby represent, understand and
					expressly agree that Emissary Health does not have control over or assume any
					responsibility for the quality, accuracy, or reliability of the information included in these
					checks. Furthermore, any inaccuracies in the report must be addressed with the
					consumer reporting agency that issued it (and not Emissary Health) within the time
					period specified in your notice. Notwithstanding this, you agree that Emissary Health is
					under no obligation to reinstate any accounts it may have terminated even if the
					information that led to the termination is subsequently changed or corrected.</p>

				<div className="divider" />

				<p>
					<b>
						4.5 Emissary Health May Regularly Verify Your Identity and the Accuracy of Your
						Representations and Warranties
					</b>
				</p>

				<p>
					By registering as a Care Provider or Care Manager, and, if applicable to you as a Care
					Provider, subject to your additional authorization, you authorize Emissary Health, and
					acknowledge that for purposes of promoting the safety and integrity of its Site and
					Service, Emissary Health reserves the right, but not the obligation, to utilize third party
					service providers to verify on an ongoing basis that your registration data is accurate
					and that the representations and warranties addressing legal matters such as
					complaints, arrests, sex offender status, etc. are also true (“Verification Checks”). These
					third parties may use data from a variety of sources, under a variety of circumstances,
					for these site safety purposes including, without limitation, information from national
					criminal databases, sex offender registries, certain media streams, terrorist watch lists,
					criminal and fugitive watch lists, fraud watch lists, law enforcement reports, and other
					data.<br /><br />
					You agree that Emissary Health may take such action in response to Verification
					Checks as it deems appropriate in its sole discretion, including without limitation
					suspending and/or terminating your membership, should it determine that you have
					violated any representation or warranty or any other provision of these Terms or are
					otherwise unsuitable for Emissary Health.<br /><br />
					You also hereby represent, understand and expressly agree that Emissary Health does
					not have control over or assume any responsibility for the quality, accuracy, or reliability
					of the information included in a Verification Check. We do not typically communicate the
					results of a Verification Check to any third party, though we reserve the right to do so for
					law enforcement or other safety-related purposes in accordance with applicable laws.
				</p>
				<div className="divider" />
				<p>
					<b>4.6 Important Limitations About Background Checks; Release of Liability for Results of
						Background Checks, Internal Background Checks, and Verification Checks</b>
				</p>

				<p>
					For Massachusetts and New Hampshire: Criminal County Searches conducted in
					Massachusetts and New Hampshire as part of the Criminal Records Check and the
					Criminal+MVR Records Check (for individuals who are believed to have lived in one or
					both of these states during the seven years preceding the background check request)
					search only the Superior Court and a single District Court in the county seat or its
					equivalent for each county listed below. Criminal records (including misdemeanors and
					felonies) from other courts in these states will not be searched.<br /><br />
					This is an illustrative, non-comprehensive, list of certain state and county limitations of
					the background checks offered through Emissary Health; additional limitations may
					apply in certain jurisdictions, including on the federal level. For example, for many states
					only certain registered sex offender information is reported, and for many states, only a
					subset of felony convictions are reported (and not any misdemeanors, charges or arrest
					records).<br /><br />
					In addition to legal and reporting system limitations of background checks, each check
					is performed with the authorization of the person being checked, using information he or
					she provides, such as home address, social security number, date of birth, and name. If
					a candidate provides incorrect information, the check might be run with inaccurate
					identifying data, which can impact the validity of the criminal check. Finally, criminal
					records are not always reported accurately or promptly, and human and electronic error
					can result in inaccurate or incomplete reporting. Consequently, even the most
					comprehensive background check offered may not disclose the existence of all criminal
					records in all jurisdictions.<br /><br />
					If you decide to access, use, or share information provided by a Background Check, you
					agree to do so in accordance with applicable law. You also agree to release, indemnify
					and hold harmless Emissary Health from any loss, liability, injury, death, damage, or
					costs that may result from your use of, reliance on, or sharing of the information
					contained in a Background Check regardless of the cause, including, without limitation,
					due to the inaccuracy or incompleteness of any such information.<br /><br />
					You expressly acknowledge that Emissary Health has no obligation to perform
					Background Checks, Internal Background Checks, or Verification Checks on any
					Registered Users. To the extent Emissary Health performs such checks on certain
					Registered Users, the checks are limited and should not be taken as complete,
					accurate, up-to-date or conclusive evidence of the accuracy of any information those
					users have provided or of their eligibility to use the Services.
				</p>

				<p>
					<b>
						5. Termination
					</b>
				</p>

				<p>
					Emissary Health reserves the right, in its sole discretion, to immediately terminate your
					access to all or part of the Emissary Health Site and/, to remove your profile and/or any
					content posted by or about you from the Site, and/or to terminate your account with
					Emissary Health, with or without notice for any reason or no reason in its sole
					discretion, including without limitation if Emissary Health should determine that you are
					not eligible to use the Services, have violated any terms stated herein or in any of the
					Additional Terms, are not suitable for participation as a Registered User, have mis-used
					or mis-appropriated Site content, including but not limited to use on a “mirrored,”
					competitive, or third-party site. Upon termination, Emissary Health shall be under no
					obligation to provide you with a copy of any content posted by or about you on the Site.
					If we terminate your registration, we have no obligation to notify you of the reason, if
					any, for your termination.<br /><br />
					You understand and agree that, following any termination of any individual’s use of the
					Site , Emissary Health has the right, but not the obligation, to send a notice of such
					termination to other Registered Users with whom we believe the individual has
					corresponded. Our decision to terminate an individual’s registration and/or to notify
					other Registered Users with whom we believe the individual has corresponded does not
					constitute, and should not be interpreted or used as information bearing on, the
					individual’s character, general reputation, personal characteristics, or mode of living.
				</p>
				<div className="divider" />

				<p>
					<b>
						6. Privacy
					</b>
				</p>
				<p>Emissary Health uses the information you provide on the Site in accordance with our
					Privacy Policy. For more information, see our full Privacy Policy, the terms of which are
					incorporated herein.</p>

				<div className="divider" />

				<p>
					<b>7. Links To External Sites</b>
				</p>
				<p>
					Links from the Site to external sites (including external sites that are framed by
					Emissary Health) or inclusion of advertisements and other third-party content on the
					Site, do not constitute an endorsement by Emissary Health of such sites or the content,
					products, advertising and other materials presented on such sites or of the products and
					services that are the subject of such third-party content, but are for users’ reference and
					convenience. Emissary Health does not control third-party sites or content, and is not
					responsible for them. Such sites and content are governed by their respective owners’
					terms of use and privacy policies, and not these Terms or Emissary Health’s Privacy
					Policy.<br /><br />
					Emissary Health expressly disclaims any liability derived from the use and/or viewing of
					links that may appear on this Site. All users hereby agree to hold Emissary Health
					harmless from any liability that may result from the use of links that may appear on the
					Site.
				</p>

				<div className="divider" />
				<p>
					<b>
						8. Payment And Refund Policy
					</b>
				</p>
				<p>In order to utilize some Emissary Health Services or product offerings, the user of such
					Services or product offerings must pay Emissary Health either a recurring subscription,
					one-time, or other fees. In addition, the user is responsible for any state or local sales
					taxes associated with the Services or product offerings purchased.</p>

				<div className="divider" />

				<p>
					<b>
						8.1 Billing and Payment
					</b>
				</p>
				<p>
					If you sign up for an Emissary Health paid membership subscription, you agree to pay
					Emissary Health all charges associated with the subscription, or product you choose, as
					described on the Site at the time you submit your payment information. You also
					authorize Emissary Health, or a third-party payment processor that works on our behalf,
					to charge your chosen payment method according to the terms of your chosen
					subscription or product. Emissary Health reserves the right to correct any errors or
					mistakes that it makes even if it has already requested or received payment.<br /><br />
					To the extent you elect to purchase other product offerings we may offer for a
					non-recurring fee, you authorize Emissary Health to charge your chosen payment
					provider for products you purchase. You agree that if Emissary Health already has your
					credit card on file as a result of prior purchases you have made, we may charge that
					credit card for the additional products you purchase.
				</p>

				<div className="divider" />

				<p>
					<b>
						8.2 Automatic Subscription Renewal and Cancellation
					</b>
				</p>
				<p>
					All paid subscriptions and recurring fee-based products will continue indefinitely until
					canceled by the user. Your subscriptions will automatically renew at the end of your
					chosen term period until the end of your subscription or until you expressly cancel any
					subscription.<br /><br />
					You may cancel your paid membership subscription at any time by following the
					instructions on your <a href="https://www.care.com/my-account-profile-p1040.html">account settings</a> page. If you cancel a paid subscription, you
					typically will be permitted to use your subscription until the end of your then-current
					subscription term. Your paid subscription will not be renewed after your then-current
					term expires, but your payment method will be charged, and you will be required to pay
					any cancellation or other fees associated with your early termination and disclosed to
					you at the time you signed up for the subscription plan.
				</p>

				<div className="divider" />

				<p>
					<b>
						8.3 Installment Plan Options
					</b>
				</p>

				<p>
					From time to time, we may offer products (including but not limited to premium
					subscriptions) that include an option to pay some or all of the applicable fees in
					installments. In the case of recurring subscriptions, the installment payment option may
					apply only to the initial subscription term, and not to any renewal or recurring terms or
					payments.<br /><br />
					By selecting an installment payment option, you agree to pay Emissary Health all
					charges associated with the subscription, Service, or product you purchase, as
					described on the Site at the time you submit your payment information. You also
					authorize Emissary Health, or a third-party payment processor that works on our behalf,
					to charge your chosen payment method according to the terms of your chosen
					installment plan.<br /><br />
					If you purchase a Service (such as a premium subscription) you agree and understand
					that, unless otherwise required by applicable law, you are committing to make all of the
					agreed-upon installment payments, regardless of whether you cancel the purchased
					Service. If you cancel your subscription prior to completing all installment payments
					due, then, unless otherwise required by applicable law, the remaining balance of the
					subscription will remain due and payable pursuant to the installment payment schedule
					you agreed to.<br /><br />
					If Emissary Health is not able to charge any payment to your chosen payment method,
					we reserve the right to pursue any remedy that may be available to us, including the
					right to suspend or terminate your premium subscription and/or your Emissary Health
					account. You agree that Emissary Health and its Affiliates have no liability related to the
					exercise of these remedies.<br /><br />
					Notwithstanding the foregoing, nothing in this Section is intended to limit or alter
					Emissary Health’s right to terminate your account at any time pursuant to Section 5
					above.
				</p>

				<div className="divider" />

				<p>
					<b>
						8.4 Free Trial Offers
					</b>
				</p>
				<p>
					Emissary Health may offer limited-time free trial subscriptions to certain users from
					time-to-time. Users who sign up for a Emissary Health Service on a free trial basis may
					have limited access to the Service and/or features of the Site. If a user signs up for a
					free trial subscription, unless he or she cancels before the expiration of the free trial
					period, the user will be charged the price then in effect for a subscription to the Service,
					unless otherwise informed by Emissary Health at the time of original subscription. If a
					user does not want to continue with the Service after the expiration of the free trial
					period, the Care Manager or Care Provider must downgrade or cancel their
					subscription, and request a refund of the subscription fee within thirty (30) days of being
					charged the subscription fee for the Service. Upon cancellation, the Care Manager or
					Care Provider’s credit card will be refunded for the amount of the most recent
					subscription charge so long as he or she has not used the subscription after the
					expiration of the free trial period.
				</p>

				<div className="divider" />

				<p>
					<b>
						8.5 Reward Points
					</b>
				</p>
				<p>
					As part of your membership or as a promotion, we may issue you reward points
					redeemable for products as described on the Site. Such points may only be redeemed
					via the Site, have no cash value, are not redeemable for cash (except to the extent
					specifically required by law), and are non-transferable and non-refundable under any
					circumstances. Reward points have no fixed value, but may be redeemed for the lesser
					of (1) the cost of the goods for which they are redeemed; (2) any maximums, caps, or
					limitations described on the Site; or (3) the maximum value of a point stated on the Site
					(which may change from time to time in the discretion of Emissary Health). Reward
					points may only be redeemed in whole increments up to the total value reflected on the
					Site. No partial redemptions of points are permitted. More than one reward point may be
					applied per transaction. Any unused reward points are forfeited immediately if you do
					not maintain the required membership status (as described on the Site), or if you or we
					close or terminate your account.
				</p>

				<div className="divider" />

				<p>
					<b>
						8.6 Refund Policy
					</b>
				</p>
				<p>
					Except as set forth in these Terms or as described on the Site at the time you make a
					purchase, all payments for subscriptions, services or products made on or through the
					Site are non-refundable, and there are no refunds or credits for unused or partially used
					subscriptions, services or products, even if you cancel your membership or a
					subscription, service, or product in the middle of a term.
				</p>

				<div className="divider" />

				<p>
					<b>
						9. Release of Liability for Conduct and Disputes
					</b>
				</p>
				<p>
					By using this Site or our Services, you hereby represent, understand, and expressly
					agree to release and hold Emissary Health (and Emissary Health’s officers, directors,
					shareholders, employees, parents, subsidiaries, other affiliates, successors, assignees,
					agents, representatives, advertisers, marketing partners, licensors, independent
					contractors, recruiters, corporate partners or resellers, or your employer, if you enrolled
					in Emissary Health through their employer’s benefits program, (“Affiliates”)) harmless
					from any claim or controversy that may arise out of:
				</p>
				<ul className="list-hollow-dot">
					<li>
						<p>
							the actions or inactions of, or the relationship between, you and any
							Care Manager, Care Provider or other user(s) of the Site; and
						</p>
					</li>
					<li>
						<p>
							any information, instruction, advice created by any Care Manager,
							Care Provider, or other third party that appeared on, or was
							communicated through, the Site Emissary Health and its Affiliates
							expressly disclaims any liability whatsoever for any damage, suits,
							claims, and/or controversies that have arisen or may arise, whether
							known or unknown, from the above.
						</p>
					</li>
				</ul>

				<div className="divider" />

				<p>
					<b>
						10. Age Restrictions
					</b>
				</p>
				<p>
					Emissary Health is intended for people 18 or over. Emissary Health will not knowingly
					collect any information from individuals under 13. Should we determine that you do not
					meet the age requirements for using our Site , your registration will be terminated
					immediately.
				</p>

				<div className="divider" />

				<p>
					<b>11. Disclaimers; Limitations; Waivers; Indemnification</b>
				</p>
				<p>
					<b>11.1 No Warranty</b>
				</p>
				<p>
					The information and materials contained on the Site, including text, graphics,
					information, links or other items are provided “as is,” “as available.” Further, opinions,
					advice, statements, offers, or other information or content made available through the
					Services, but not directly by Emissary Health, are those of their respective authors, and
					should not necessarily be relied upon. Such authors are solely responsible for such
					content.
				</p>

				<div className="divider" />

				<p>
					<b>11.2 Assumption of Risk</b>
				</p>
				<p>
					While Emissary Health takes certain steps to help promote the safety of our site, finding
					care or care-related jobs via an online platform like ours comes with certain inherent
					risks. We do not provide any training, supervision, or monitoring of Care Managers or
					Care Providers, and we cannot guarantee that all of your interactions with other
					Registered Users, site visitors, their families, or others associated with them, will always
					be 100% safe and respectful. You agree to assume all risks when using the Site and the
					Services, including but not limited to injury, illness, death, and all other risks associated
					with any online or offline interactions with users of the Site. You also agree not to rely
					solely on steps Emissary Health may take to vet or screen Care Providers or Care
					Managers and/or their Content, or otherwise to promote the safety of the site. You
					further agree to take all necessary precautions when interacting with other site visitors,
					Registered Users, their families, and others associated with them.
				</p>

				<div className="divider" />

				<p>
					<b>11.3 Limitation of Liability</b>
				</p>
				<p>
					Incidental Damages and Aggregate Liability. In no event will Emissary Health be liable
					for any indirect, special, incidental, or consequential damages, losses or expenses
					arising out of or relating to the use or inability to use the Site, including without limitation
					damages related to any information received from the Site, removal of content from the
					Site, including profile information, any email distributed to any user or any linked web
					site or use thereof or inability to use by any party, or in connection with any termination
					of your subscription or ability to access the Site, failure of performance, error, omission,
					interruption, defect, delay in operation or transmission, computer virus or line or system
					failure, even if Emissary Health, or representatives thereof, are advised of the possibility
					of such damages, losses or expenses.<br /><br />
					No Liability for non-Emissary Health Actions. In no event will Emissary Health be liable
					for any damages whatsoever, whether direct, indirect, general, special, compensatory,
					consequential, or otherwise, arising out of or relating to the conduct of you or anyone
					else in connection with the use of the site or any agreement or relationship formed
					using the site or service, including without limitation, bodily injury, emotional distress,
					and/or any other damages resulting from anyone’s reliance on information or other
					content posted on the site, or transmitted to or by any users or any other interactions
					with other registered users of the site , whether online or offline. this includes any
					claims, losses or damages arising from the conduct of users who have registered under
					false pretenses or who attempt to defraud or harm you.<br /><br />
					In addition to the preceding paragraphs of this section and other provisions of these
					Terms, any advice that may be posted on the Site is for informational purposes only and
					is not intended to replace or substitute for any professional financial, medical, legal, or
					other advice. Emissary Health makes no representations or warranties and expressly
					disclaims any and all liability concerning any treatment, action by, or effect on any
					person following the information offered or provided within or through the Site. If you
					have specific concerns or a situation arises in which you require professional or medical
					advice, you should consult with an appropriately trained and qualified specialist.
				</p>

				<div className="divider" />

				<p>
					<b>
						11.4 Indemnification
					</b>
				</p>
				<p>By agreeing to these Terms, users of the site agree to indemnify, defend and hold
					harmless Emissary Health and its Affiliates from and against any and all claims, losses,
					expenses or demands of liability, including reasonable attorneys’ fees and costs
					incurred by Emissary Health and its Affiliates in connection with any claim by a third
					party (including an intellectual property claim) arising out of (i) materials and content you
					submit, post or transmit through the Site, (ii) use of the Site by you in violation of these
					Terms of Use or in violation of any applicable law, or (iii) any relationship or agreement
					formed with a Care Manager or Care Provider using the Site . Users further agree that
					they will cooperate as reasonably required in the defense of such claims. Emissary
					Health and its Affiliates reserve the right, at their own expense, to assume the exclusive
					defense and control of any matter otherwise subject to indemnification by users, and
					users shall not, in any event, settle any claim or matter without the written consent of
					Emissary Health. Users further agree to hold harmless Emissary Health and its Affiliates
					from any claim arising from a third party’s use of information or materials of any kind
					that users post to the Site.</p>

				<div className="divider" />

				<p>
					<b>
						12. Copyright Notices/Complaints
					</b>
				</p>
				<p>
					It is Emissary Health’s policy to respond to notices of alleged copyright infringement
					with the Digital Millennium Copyright Act (“DMCA”). If you believe any materials
					accessible on or from our Site infringe your copyright, you may request removal of those
					materials (or access thereto) from the Site by contacting Emissary Health’s copyright
					agent (identified below) and providing the following information:
				</p>
				<ul>
					<li>
						<p>
							1. Identification of the copyrighted work that you believe to be infringed.
							Please describe the work, and where possible include a copy or the
							location (e.g., URL) of an authorized version of the work.
						</p>
					</li>
					<li>
						<p>
							2. Identification of the material that you believe to be infringing and its
							location. Please describe the material and provide us with its URL or any
							other pertinent information that will allow us to locate the material.
						</p>
					</li>
					<li>
						<p>
							3. Your name, address, telephone number and (if available) e-mail address.
						</p>
					</li>
					<li>
						<p>
							4. A statement that you have a good faith belief that the complained of use of
							the materials is not authorized by the copyright owner, its agent, or the
							law.
						</p>
					</li>
					<li>
						<p>
							5. A statement that the information that you have supplied is accurate, and
							indicating that “under penalty of perjury,” you are the copyright owner or
							are authorized to act on the copyright owner’s behalf.
						</p>
					</li>
					<li>
						<p>
							6. A signature or the electronic equivalent from the copyright holder or
							authorized representative.
						</p>
					</li>
				</ul>

				<div className="divider" />

				<p>Emissary Health’s agent for copyright issues relating to this Site is as follows:</p>
				<div className="divider" />
				<a className="email" href="mailto:support@emissaryhealth.org">support@emissaryhealth.org</a>
				<div className="divider" />
				<p>
					In an effort to protect the rights of copyright owners, Emissary Health maintains a policy
					for the termination, in appropriate circumstances, of Members and other users of this
					Site who are repeat infringers.
				</p>

				<div className="divider" />

				<p>
					<b>13. Agreement to Arbitrate</b>
				</p>
				<p>
					<b>13.1 Agreement to Arbitrate</b>
				</p>
				<p>
					This Section 13 is referred to in these Terms as the “Arbitration Agreement”. Unless you
					opt-out in accordance with the opt-out procedures set forth in Section 13.8 below, you
					agree that all claims relating to or arising out of these Terms or the breach thereof,
					whether sounding in contract, tort, or otherwise that have arisen or may arise between
					you and Emissary Health or a Emissary Health Affiliate, whether relating to these Terms
					(including any alleged breach thereof), the Services, the Site, or otherwise, shall be
					resolved exclusively through final and binding arbitration, rather than a court, in
					accordance with the terms of this Arbitration Agreement, except you may assert
					individual claims in small claims court, if your claims qualify. Your rights will be
					determined by a neutral arbitrator, not a judge or jury. The Federal Arbitration Act
					governs the interpretation and enforcement of this Arbitration Agreement.
				</p>

				<div className="divider" />

				<p>
					<b>		13.2 Prohibition of Class and Representative Actions and Non-Individualized
						Relief</b>
				</p>
				<p>
					You and emissary health agree that each of us may bring claims against the other only
					on an individual basis and not as a plaintiff or class member in any purported class or
					representative arbitration, action or proceeding. unless both you and emissary health
					expressly agree otherwise, the arbitrator may not consolidate or join more than one
					person’s or party’s claims against emissary health and may not otherwise preside over
					any form of a consolidated, representative, or class proceeding. also, the arbitrator may
					award relief (including monetary, injunctive, and declaratory relief) only in favor of the
					individual party seeking relief and only to the extent necessary to provide relief
					necessitated by that party’s individual claim(s). any relief awarded cannot affect other
					emissary health users. If any court or arbitrator determines that the class action waiver
					set forth in this paragraph is void or unenforceable for any reason or that an arbitration
					can proceed on a class basis, then the arbitration provision set forth above shall be
					deemed null and void in its entirety and the parties shall be deemed to have not agreed
					to arbitrate disputes.
				</p>

				<div className="divider" />

				<p>
					<b>13.3 Pre-Arbitration Dispute Resolution</b>
				</p>
				<p>
					Emissary Health is always interested in resolving disputes amicably and efficiently. So
					before you commence arbitration, we suggest that you contact us to explain your
					complaint, as we may be able to resolve it without the need for arbitration. You may
					contact us at <a className="email" href="mailto:support@emissaryhealth.org">support@emissaryhealth.org</a>.
				</p>

				<div className="divider" />

				<p>
					<b>13.4 Arbitration Procedures</b>
				</p>

				<p>If we cannot resolve a Claim informally, any Claim either of us asserts will be resolved
					only by binding arbitration and not in courts of general jurisdiction. Arbitration will be
					conducted by a neutral arbitrator in accordance with the rules of JAMS that are in effect
					at the time the arbitration is initiated (collectively referred to as the “JAMS Rules”), as
					modified by this Arbitration Agreement, and excluding the JAMS Class Action
					Procedures. For information on JAMS, please visit its website,
					&nbsp; <a href="https://www.jamsadr.com/">https://www.jamsadr.com/</a>. Information about JAMS’s Rules and fees for consumer
					disputes can be found at the JAMS consumer arbitration page,
					&nbsp; <a href="https://www.jamsadr.com/rules-comprehensive-arbitration/">https://www.jamsadr.com/rules-comprehensive-arbitration/</a>. If there is any inconsistency
					between the JAMS Rules and this Arbitration Agreement, the terms of this Arbitration
					Agreement will control unless the arbitrator determines that the application of the
					inconsistent Arbitration Agreement terms would not result in a fundamentally fair
					arbitration. The arbitrator must also follow the provisions of these Terms as a court
					would, including without limitation, the limitation of liability provisions in Section 11.
					Although arbitration proceedings are usually simpler and more streamlined than trials
					and other judicial proceedings, the arbitrator can award the same damages and relief on
					an individual basis that a court can award to an individual under the Terms and
					applicable law. Decisions by the arbitrator are enforceable in court and may be
					overturned by a court only for very limited reasons.<br /><br />
					To commence an arbitration against Emissary Health, you must write a demand for
					arbitration that includes a description of the dispute and the amount of damages sought
					to be recovered. You can find a copy of a Demand for Arbitration at <a href="www.jamsadr.com.">www.jamsadr.com.</a>
					You should send three copies of the Demand, plus the appropriate filing fee, to JAMS at
					500 North State College Blvd., Suite 600, Orange, CA 92868, and send one copy to
					Emissary Health, Inc., Attn: Legal Department, 816 Congress St., Suite 800, Austin, TX
					78701. For more information, see the JAMS arbitration rules and forms,
					&nbsp;<a href="https://www.jamsadr.com/rules-download/">https://www.jamsadr.com/rules-download/</a>. You may represent yourself in the arbitration
					or be represented by an attorney or another representative. Once we receive your
					arbitration claim, we may assert any counterclaims we may have against you.<br /><br />
					The arbitration shall be held in the county in which you reside or at another mutually
					agreed location. If the value of the relief sought is $10,000 or less you or Emissary
					Health may elect to have the arbitration conducted by telephone or based solely on
					written submissions, which election shall be binding on you and Emissary Health
					subject to the arbitrator’s discretion to require an in-person hearing, if the circumstances
					warrant. Attendance at any in-person hearing may be made by telephone by you and/or
					Emissary Health, unless the arbitrator requires otherwise.<br /><br />
					The arbitrator, and not any federal, state or local court or agency, shall have exclusive
					authority to resolve all claims relating to or arising out of this contract, or the breach
					thereof, whether sounding in contract, tort, or otherwise and all disputes arising out of or
					relating to the interpretation, applicability, enforceability or formation of these Terms,
					including, but not limited to any claim that all or any part of these Terms are void or
					voidable, or whether a claim is subject to arbitration. The arbitrator shall be empowered
					to grant whatever relief would be available in a court under law or in equity. The
					arbitrator’s award shall be written, and binding on the parties and may be entered as a
					judgment in any court of competent jurisdiction.<br /><br />
					The arbitrator will decide the substance of all claims in accordance with the laws of the
					State of Delaware, including recognized principles of equity, and will honor all claims of
					privilege recognized by law. The arbitrator shall not be bound by rulings in prior
					arbitrations involving different Emissary Health users, but is bound by rulings in prior
					arbitrations involving the same Emissary Health user to the extent required by
					applicable law.</p>

				<div className="divider" />

				<p>
					<b>13.5 Costs of Arbitration</b>
				</p>
				<p>
					Payment of all filing, administration, and arbitrator fees (collectively, the “Arbitration
					Fees”) will be governed by the JAMS Rules, unless otherwise provided in this
					Agreement to Arbitrate. If you demonstrate to the arbitrator that you are economically
					unable to pay your portion of the Arbitration Fees or if the arbitrator otherwise
					determines for any reason that you should not be required to pay your portion of the
					Arbitration Fees, Emissary Health will pay your portion of such fees. In addition, if you
					demonstrate to the arbitrator that the costs of arbitration will be prohibitive as compared
					to the costs of litigation, Emissary Health will pay as much of the Arbitration Fees as the
					arbitrator deems necessary to prevent the arbitration from being cost-prohibitive. Each
					party will be responsible for all other fees it incurs in connection with the arbitration,
					including without limitation, all attorney fees. In the event the arbitrator determines the
					claim(s) you assert in the arbitration to be frivolous, you agree to reimburse Emissary
					Health for all fees associated with the arbitration paid by Emissary Health on your behalf
					that you otherwise would be obligated to pay under the JAMS rules.
				</p>

				<div className="divider" />

				<p>
					<b>13.6 Confidentiality</b>
				</p>
				<p>
					All aspects of the arbitration proceeding, and any ruling, decision or award by the
					arbitrator, will be strictly confidential for the benefit of all parties.
				</p>

				<div className="divider" />

				<p>
					<b>13.7 Opt-Out Procedure</b>
				</p>
				<p>
					You can choose to reject this Arbitration Agreement by mailing us a written opt-out
					notice (“Opt-Out Notice”) in accordance with the terms of this Section. For new
					Emissary Health users, the Opt-Out Notice must be postmarked no later than 30 Days
					after the date you use our Site for the first time. The Opt-Out Notice must state that you
					do not agree to the Arbitration Agreement and must include your name, address, phone
					number, and the email address(es) used to log in to the Emissary Health account(s) to
					which the opt-out applies. You must sign the Opt-Out Notice for it to be effective. This
					procedure is the only way you can opt out of the Arbitration Agreement. If you opt out of
					the Arbitration Agreement, Emissary Health will likewise not be bound by these
					arbitration provisions. All other terms of these Terms will continue to apply. Opting out of
					the Arbitration Agreement has no effect on any previous, other, or future arbitration
					agreements that you may have with us. Emissary Health users who accepted a
					previous version of these Terms that included an arbitration agreement, and who did not
					timely opt out of that arbitration agreement, remain bound by the last arbitration
					agreement that they accepted. Upon receipt of a valid Opt-Out Notice, Emissary Health
					will provide the opting out user with a copy of the arbitration agreement from the last
					version of the Terms that the user accepted, if any exists.
				</p>

				<div className="divider" />

				<p>
					<b>13.8 Future Changes to this Arbitration Agreement</b>
				</p>
				<p>Notwithstanding any provision in these Terms to the contrary, you and we agree that if
					we make any change to this Arbitration Agreement (other than a change to any notice
					address or website link provided herein) in the future, such change shall not be effective
					until at least 60 days from the date of posting, and shall not apply to any claim that was
					filed in a legal proceeding against Emissary Health prior to the effective date of the
					change. Moreover, if we seek to terminate this Arbitration Agreement from these Terms,
					such termination shall not be effective until 30 days after the version of these Terms not
					containing the Arbitration Agreement is posted to the Site, and shall not be effective as
					to any claim that was filed in a legal proceeding against Emissary Health prior to the
					effective date of removal.</p>

				<div className="divider" />

				<p>
					<b>14. Governing Law and Jurisdiction</b>
				</p>
				<p>
					These Terms, and all claims relating to or arising out of this contract, or the breach
					thereof, whether sounding in contract, tort, or otherwise, shall be governed by the laws
					of the State of Delaware, including Delaware’s statutes of limitations governing your
					claim, without giving effect to its principles of conflicts of law, provided that the Federal
					Arbitration Act shall govern the interpretation and enforcement of Section 13, the
					Arbitration Agreement.<br /><br />
					Unless you and we agree otherwise, in the event that the Arbitration Agreement is found
					not to apply to you or to a particular claim or dispute (except for small-claims court
					actions), either as a result of your decision to opt-out of the Arbitration Agreement or as
					a result of a decision by the arbitrator or a court order, you agree that any claim or
					dispute that has arisen or may arise between you and Emissary Health must be
					resolved exclusively by a state or federal court located in the State of Delaware.<br /><br />
					You and Emissary Health agree to submit to the personal jurisdiction of the courts
					located within the State of Delaware for the purpose of litigating all such claims or
					disputes.
				</p>

				<div className="divider" />

				<p>
					<b>15. Consent to Electronic Communication</b>
				</p>
				<p>	By using the Site of Emissary Health, you agree to allow Emissary Health to
					communicate with you electronically, and you consent to electronic delivery of notices,
					documents, or products (including, without limitation, reports or copies of Background
					Checks and Preliminary Membership Screens) from Emissary Health via the Emissary
					Health Site, mobile application, online messaging platform, or e-mail. You also agree to
					check your Emissary Health account, alerts, and messages, and the e-mail account
					reflected on your Emissary Health on a reasonably regular basis to stay apprised of
					important notices and information about your account.</p>

				<div className="divider" />

				<p>
					<b>16. Miscellaneous</b>
				</p>
				<p>
					Nothing in this Agreement shall be construed as making either party the partner, joint
					venturer, agent, legal representative, employer, contractor or employee of the other.
					Neither party shall have, or hold itself out to any third party as having any authority to
					make any statements, representations or commitments of any kind, or to take any
					action, that shall be binding on the other, except as provided for herein or authorized in
					writing by the party to be bound. The invalidity, illegality or unenforceability of any term
					or provision of these Terms shall in no way effect the validity, legality or enforceability of
					any other term or provision of these Terms. Each Affiliate is expressly made a third party
					beneficiary of this Agreement and may enforce this Agreement directly against you. This
					Agreement will be binding on and will insure to the benefit of the legal representatives,
					successors and assigns of the parties hereto.
				</p>

				<div className="divider" />

				<p>
					<b>17. Severability</b>
				</p>
				<p>If a court decides that any term or provision of these Terms other than Section 13.2 is
					invalid or unenforceable, the parties agree to replace such term or provision with a term
					or provision that is valid and enforceable and that comes closest to expressing the
					intention of the invalid or unenforceable term or provision, and these Terms shall be
					enforceable as so modified. If a court decides that any of the provisions of Section 13.2
					are invalid or unenforceable, then the entirety of Section 13 shall be null and void. The
					remainder of the Terms will continue to apply.</p>

				<div className="divider" />

				<p>
					<b>18. Contact Information</b>
				</p>
				<p>
					If you have any questions or need further information as to the Site provided by
					Emissary Health, or need to notify Emissary Health as to any matters relating to the Site
					please contact Emissary Health at: <br /><br />
					<a className="email" href="mailto:support@emissaryhealth.org">support@emissaryhealth.org</a>
				</p>
			</div>
		</>
	);
};

export default Terms;
